/**
 * Utility helper to format raw database game names (e.g. 'lsraware', 'lsrpro')
 * into user-friendly full display titles across the frontend.
 */
export const GAME_TITLE_MAP = {
  "lsraware": "Life-Saving Rules Aware",
  "lsrawarevapi": "Life-Saving Rules Aware",
  "life saving rules aware": "Life-Saving Rules Aware",
  "lsr aware": "Life-Saving Rules Aware",

  "lsrpro": "Life-Saving Rules Pro",
  "lsrprovapi": "Life-Saving Rules Pro",
  "life saving rules pro": "Life-Saving Rules Pro",
  "lsr pro": "Life-Saving Rules Pro",

  "lsrroad": "Life-Saving Rules Road",
  "lsrdd": "Life-Saving Rules Road",
  "lsrddvapi": "Life-Saving Rules Road",
  "life saving rules road": "Life-Saving Rules Road",
  "lsr road": "Life-Saving Rules Road",

  "drivingaware": "Driving Aware All Roads",
  "vsrstaware": "Driving Aware All Roads",
  "vsrstawarevapi": "Driving Aware All Roads",
  "driving aware all roads": "Driving Aware All Roads",
  "driving aware": "Driving Aware All Roads",

  "blacktopdriving": "Driving Pro Blacktop",
  "vsrstblacktop": "Driving Pro Blacktop",
  "vsrstblacktopvapi": "Driving Pro Blacktop",
  "driving pro blacktop": "Driving Pro Blacktop",
  "driving pro black top": "Driving Pro Blacktop",

  "gradedroaddriving": "Driving Pro Graded Road",
  "vsrstgraded": "Driving Pro Graded Road",
  "vsrstgradedvapi": "Driving Pro Graded Road",
  "driving pro graded road": "Driving Pro Graded Road",

  "processsafety": "Process Safety",
  "ociprocesssafety": "Process Safety",
  "ociprocesssafetyvapi": "Process Safety",
  "process safety": "Process Safety",
};

export const formatGameName = (name) => {
  if (!name) return "";
  const cleaned = name
    .toLowerCase()
    .replace(/[™®]/g, "")
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const noSpace = cleaned.replace(/\s+/g, "");

  return GAME_TITLE_MAP[cleaned] || GAME_TITLE_MAP[noSpace] || name;
};
